import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSearch } from "../../../contexts/SearchContext";
import { isAgentFlightResultsListUrl } from "../flightBookingPathUtils";
import { useBookingFlow } from "./hooks/useBookingFlow";

/**
 * בכתובת …/flights/results או בזמן טעינת חיפוש חייב להופיע גוף התוצאות גם אם
 * currentStep עדיין "search" — אחרת FlightWizardShell משתמש ב-searchPhase ומסתיר את כל הילדים.
 */
export function BookingFlowStepShell({ step, children }) {
  const { pathname } = useLocation();
  const { flightStep: routeFlightStep } = useParams();
  const { loading } = useSearch();
  const { currentStep } = useBookingFlow();
  const onResultsListUrl = isAgentFlightResultsListUrl(pathname, routeFlightStep);
  const showResultsWhileSearchPending =
    currentStep === "search" && (onResultsListUrl || Boolean(loading));

  if (step === "search" && showResultsWhileSearchPending) {
    return null;
  }

  if (step === "results" && showResultsWhileSearchPending) {
    return <div className="fw-step-mount">{children}</div>;
  }

  if (currentStep !== step) return null;
  return <div className="fw-step-mount">{children}</div>;
}
